import { useTypedQuery } from "hooks";
import { BrandsDashboardQueryKeys } from "modules/BrandsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { BrandGroup } from "models";

const sortBrandGroupsByName = (brandGroups: BrandGroup[]) => brandGroups.toSorted((a, b) => a.name.localeCompare(b.name));

export const useBrandGroupsQuery = () =>
  useTypedQuery({
    queryKey: BrandsDashboardQueryKeys.brandGroups,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.get(endpoint, baseUrl)).data.brand_groups,
    select: sortBrandGroupsByName
  });
